var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgUplift(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#009245",
    fillRule: "evenodd"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M2.534 18.716l-.936.316V20h4v-2.752c-1.2.814-2.76 1.326-3.064 1.468z",
    opacity: 0.5,
    fill: "#010101",
    fillRule: "nonzero"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M6.798 16.466V20h4v-6.118c-1.4 1.004-2.6 1.874-4 2.584z",
    opacity: 0.75,
    fill: "#010101",
    fillRule: "nonzero"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M16.598 8.758V20h-4.4v-7.132c1.4-1.092 3.6-2.588 4.4-4.1zm3.4.298L17.568 0l-4.17 2.286L9.22 4.572l3.336 1.388C8.732 10.766.288 14.458.198 14.496l1.54 3.42c.418-.182 10.26-4.468 14.434-10.452l3.826 1.592z",
    fill: "#010101",
    fillRule: "nonzero"
  })));
}
export default SvgUplift;